<div class="background">
  <img
    style="width: 200px; height: auto"
    src="../../../assets/img/logo.png"
    alt=""
  />

  <mat-card class="login-card">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <h2>Se connecter</h2>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Adresse email</mat-label>
        <input matInput formControlName="email" type="email" />
        <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
          Adresse email obligatoire
        </mat-error>
        <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
          Adresse email invalide
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" type="password" />
        <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
          Mot de passe obligatoire
        </mat-error>
        <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
          16 caractères au minimum
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="loginForm.invalid"
      >
        Se connecter
      </button>
    </form>
  </mat-card>
</div>
